
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eddie-paredes",
      function () {
        return require("private-next-pages/eddie-paredes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eddie-paredes"])
      });
    }
  